(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ccc-mobile-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ccc-mobile-details')) {
    customElements.define('ccc-mobile-details', class extends HTMLElement {
      connectedCallback() {
        this.description = this.querySelector('.ccc-mobile-details__description');
        if (!this.description) return;
        this.media = matchMedia('(max-width: 767px)');
        this.mobileOpen = true;
        this.ready = false;
        this.onToggle = () => {
          if (this.ready && this.media.matches) this.mobileOpen = this.description.open;
        };
        this.sync = () => {
          this.description.open = this.media.matches ? this.mobileOpen : true;
          this.ready = true;
        };
        this.description.addEventListener('toggle', this.onToggle);
        this.media.addEventListener('change', this.sync);
        const expandable = this.querySelector('product-description-expand');
        if (expandable && !customElements.get('product-description-expand')) {
          customElements.whenDefined('product-description-expand').then(() => {
            if (this.isConnected) this.sync();
          });
        } else {
          this.sync();
        }
      }
      disconnectedCallback() {
        this.description?.removeEventListener('toggle', this.onToggle);
        this.media?.removeEventListener('change', this.sync);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ccc-mobile-included"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ccc-mobile-included')) {
    customElements.define('ccc-mobile-included', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        document.addEventListener('variantChange', event => {
          if (event.detail?.sectionId !== this.dataset.sectionId) return;
          const replacement = event.detail.html?.getElementById(this.id);
          const content = this.querySelector('[data-mobile-info-content]');
          const nextContent = replacement?.querySelector('[data-mobile-info-content]');
          if (content && nextContent) content.innerHTML = nextContent.innerHTML;
        }, { signal: this.abort.signal });
      }
      disconnectedCallback() { this.abort?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ccc-mobile-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ccc-mobile-purchase')) {
    customElements.define('ccc-mobile-purchase', class extends HTMLElement {
      connectedCallback() {
        this.section = document.getElementById(`shopify-section-${this.dataset.sectionId}`);
        this.form = this.section?.querySelector('product-form');
        if (!this.form) return;
        this.picker = this.section.querySelector('product-variant-selector');
        this.price = this.querySelector('[data-price]');
        this.addButton = this.querySelector('[data-sticky-add]');
        this.buttonLabel = this.querySelector('[data-button-label]');
        this.status = this.querySelector('[data-status]');
        this.installments = this.querySelector('[data-installments]');
        this.installmentsVariant = this.querySelector('[data-installments-variant]');
        this.expanded = window.scrollY >= 80;
        this.variants = JSON.parse(this.picker?.querySelector('[data-variants-json]')?.textContent || '[]');
        this.media = matchMedia('(max-width: 767px)');
        this.abort = new AbortController();
        const signal = this.abort.signal;
        window.addEventListener('scroll', () => this.updateScrollState(), { passive: true, signal });
        window.addEventListener('pageshow', () => this.updateScrollState(), { signal });
        this.addEventListener('focusout', () => queueMicrotask(() => {
          if (this.isConnected) this.updateScrollState();
        }), { signal });
        this.onVariantChange = event => {
          if (event.detail?.sectionId !== this.dataset.sectionId) return;
          this.pending = false;
          this.status.textContent = '';
          this.variant = event.detail.variant || this.variant;
          const replacement = event.detail.html?.querySelector('ccc-mobile-purchase');
          if (replacement) this.price.innerHTML = replacement.querySelector('[data-price]').innerHTML;
          queueMicrotask(() => this.sync());
        };
        document.addEventListener('variantChange', this.onVariantChange, { signal });
        document.addEventListener('variantLoading', event => {
          if (event.detail?.sectionId !== this.dataset.sectionId) return;
          this.pending = true;
          this.sync();
        }, { signal });
        this.addButton.addEventListener('click', () => {
          this.sync();
          if (!this.addButton.disabled) {
            this.sourceButton?.click();
          }
        }, { signal });
        this.media.addEventListener('change', () => this.updateVisibility(), { signal });
        this.formObserver = new MutationObserver(() => this.sync());
        this.formObserver.observe(this.form, { subtree: true, childList: true, attributes: true, attributeFilter: ['current-variant', 'disabled', 'loading', 'aria-busy'] });
        this.sizeObserver = new ResizeObserver(() => {
          if (!this.hidden && this.media.matches) document.documentElement.style.setProperty('--ccc-mobile-purchase-height', `${Math.ceil(this.getBoundingClientRect().height)}px`);
        });
        this.sizeObserver.observe(this);
        this.sync();
      }
      sync() {
        if (!this.form?.isConnected) return;
        const selectedId = this.form.querySelector('[data-variant-id-input]')?.value || this.dataset.variantId;
        this.variant = this.variants.find(variant => String(variant.id) === String(selectedId)) || this.variant;
        const button = this.form.querySelector('[data-add-button]') || this.form.querySelector('button');
        this.sourceButton = button;
        const sourceId = this.form.getAttribute('current-variant');
        const matches = !this.variant || String(this.variant.id) === String(sourceId);
        const loading = this.pending || !matches || button?.hasAttribute('loading');
        const unavailable = !button || button.disabled || !button.hasAttribute('data-add-button') || this.variant?.available === false;
        this.addButton.disabled = Boolean(loading || unavailable);
        this.addButton.setAttribute('aria-busy', String(Boolean(loading)));
        this.buttonLabel.textContent = loading ? this.dataset.loadingLabel : unavailable ? this.dataset.soldOutLabel : this.dataset.addLabel;
        if (this.installments) {
          this.installments.hidden = Boolean(loading || unavailable);
          if (!loading && this.installmentsVariant && selectedId && this.installmentsVariant.value !== String(selectedId)) {
            this.installmentsVariant.value = String(selectedId);
            this.installmentsVariant.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
        this.updateVisibility();
      }
      updateScrollState() {
        const position = Math.max(0, window.scrollY || 0);
        if (position >= 80) {
          this.expanded = true;
        } else if (position <= 24 && !this.contains(document.activeElement)) {
          this.expanded = false;
        }
        this.updateCompactState();
      }
      updateCompactState() {
        const compact = Boolean(this.media?.matches && !this.expanded);
        this.toggleAttribute('data-compact', compact);
      }
      updateVisibility() {
        const mobile = this.media.matches;
        const visible = mobile && Boolean(this.sourceButton);
        this.hidden = !visible;
        this.section.classList.toggle('ccc-mobile-purchase-active', visible);
        this.updateCompactState();
        document.documentElement.classList.toggle('ccc-mobile-purchase-ready', visible);
        document.documentElement.classList.toggle('ccc-mobile-purchase-visible', visible);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.formObserver?.disconnect();
        this.sizeObserver?.disconnect();
        this.section?.classList.remove('ccc-mobile-purchase-active');
        document.documentElement.classList.remove('ccc-mobile-purchase-ready', 'ccc-mobile-purchase-visible');
        document.documentElement.style.removeProperty('--ccc-mobile-purchase-height');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ccc-mobile-variant-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ccc-mobile-variant-options')) {
    customElements.define('ccc-mobile-variant-options', class extends HTMLElement {
      connectedCallback() {
        this.section = document.getElementById(`shopify-section-${this.dataset.sectionId}`);
        this.picker = this.section?.querySelector('product-variant-selector');
        this.form = this.section?.querySelector('product-form');
        this.selects = [...this.querySelectorAll('[data-mobile-option]')];
        if (!this.picker || !this.form || !this.selects.length) return;
        this.variants = JSON.parse(this.picker.querySelector('[data-variants-json]')?.textContent || '[]');
        if (!this.variants.length) return;
        this.nativePanel = this.picker.closest('[class~="#product-meta-block"]') || this.picker;
        this.nativePanel.dataset.cccMobileNativeOptions = '';
        this.section.classList.add('ccc-mobile-inline-options-active');
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.addEventListener('change', event => {
          const select = event.target.closest('[data-mobile-option]');
          if (!select || select.disabled) return;
          const source = [...this.picker.querySelectorAll('input, select')].find(input => input.name === select.dataset.optionName && (input.tagName === 'SELECT' || input.value === select.value));
          if (!source) { this.sync(); return; }
          if (source.tagName === 'SELECT') {
            source.value = select.value;
            source.dispatchEvent(new Event('change', { bubbles: true }));
          } else {
            source.click();
          }
        }, { signal });
        document.addEventListener('variantLoading', event => {
          if (event.detail?.sectionId !== this.dataset.sectionId) return;
          this.pending = true;
          this.sync();
        }, { signal });
        document.addEventListener('variantChange', event => {
          if (event.detail?.sectionId !== this.dataset.sectionId) return;
          this.pending = false;
          queueMicrotask(() => { if (this.isConnected) this.sync(); });
        }, { signal });
        this.observer = new MutationObserver(() => this.sync());
        this.observer.observe(this.form, { attributes: true, attributeFilter: ['current-variant'] });
        this.setAttribute('data-ready', '');
        this.sync();
      }
      sync() {
        const id = this.form.querySelector('[data-variant-id-input]')?.value || this.form.getAttribute('current-variant');
        const variant = this.variants.find(item => String(item.id) === String(id));
        if (!variant) return;
        this.setAttribute('aria-busy', String(Boolean(this.pending)));
        for (const select of this.selects) {
          const index = Number(select.dataset.optionIndex);
          select.value = variant.options[index];
          select.disabled = Boolean(this.pending);
          for (const option of select.options) {
            const available = this.variants.some(item => item.available && item.options[index] === option.value);
            option.disabled = !available;
            option.textContent = option.value + (available ? '' : ` — ${this.dataset.soldOutLabel}`);
          }
        }
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        if (this.nativePanel) delete this.nativePanel.dataset.cccMobileNativeOptions;
        this.section?.classList.remove('ccc-mobile-inline-options-active');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
